import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent from './MenuContent';
import OptionsMenu from './OptionsMenu';
import { getInitials, getUserAffiliationLabel, getUserDisplayName } from '../utils/userProfile';



const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu() {

  const user = useSelector((state) => state.auth.user);
  const partnerProfile = useSelector((state) => state.auth.partnerProfile);

  if (!user) {
    return null; // or a skeleton / placeholder
  }

  const displayName = getUserDisplayName(user, partnerProfile);
  const affiliationLabel = getUserAffiliationLabel(partnerProfile);

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 1.5,
        }}
      >
        <Box
          component="img"
          src="/images/AMX-xConsole-Logo.png"
          alt="Agile Manufacturing eXchange Logo"
          sx={{
            height: 100,
            width: 'auto',
          }}
        />
      </Box>
      <Divider />
      <MenuContent />
      {/* <CardAlert /> */}
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Avatar
          sizes="small"
          alt={displayName}
          sx={{ width: 36, height: 36 }}
        >
          {getInitials(displayName)}
        </Avatar>
        <Box sx={{ mr: 'auto', minWidth: 0 }}>
          <Typography variant="body2" noWrap sx={{ fontWeight: 500, lineHeight: '16px' }}>
            {displayName}
          </Typography>
          <Typography variant="caption" noWrap sx={{ color: 'text.secondary', display: 'block' }}>
            {affiliationLabel}
          </Typography>
        </Box>
        <OptionsMenu />
      </Stack>
    </Drawer>
  );
}
